const messageCategory = {
    path: 'category',
    component: resolve => require(['@/pages/admin/message/category.vue'], resolve)
}

export default messageCategory